import { useState } from "react";
import { useAuth } from "../../components/context/LoginContext/AuthContext";

/**
 * @typedef {object} SetParentPasswordPayload
 * @property {string} email
 * @property {string} token
 * @property {string} password
 */

/**
 * Hook to set Parent School Password
 * @returns {{
 *  setParentPassword: (payload: SetParentPasswordPayload) => Promise<void>,
 *  loading: boolean,
 *  error: string | null,
 *  success: boolean
 * }}
 */
const useSetParentPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const setParentPassword = async ({ email, token, password }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetchWithAuth(
        `${apiUrl}/auth/set-parent-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            token,
            password,
          }),
        },
      );

      const data = await response.json();

      // ❌ ANY failure → reject
      if (!response.ok || data?.success === false) {
        const error = new Error(data?.message || "Something went wrong");
        error.error_code = data?.error_code;
        error.retry_after = data?.retry_after;
        throw error;
      }

      return data; // ✅ SUCCESS ONLY
    } catch (err) {
      setError(err.message);
      throw err; // ❗ REQUIRED
    } finally {
      setLoading(false);
    }
  };

  return { setParentPassword, loading, error, success };
};

export default useSetParentPassword;
